import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../section_title';
import { getTranslationNode } from '../services';
import { TPerformanceSection } from './types';
import './PerformanceSection.scss';

const PerformanceSection: React.FC<TPerformanceSection> = ({
  limiting_drivers,
  supporting_drivers
}) => {
  const { t, i18n } = useTranslation();
  const [driving, setDriving] = useState<string | undefined>(undefined);
  const [limiting, setLimiting] = useState<string | undefined>(undefined);

  useEffect(() => {
    const language = (i18n.language || i18n.resolvedLanguage) ?? 'en';
    const drivingNode = getTranslationNode(supporting_drivers, language);
    const limitingNode = getTranslationNode(limiting_drivers, language);
    setDriving(drivingNode);
    setLimiting(limitingNode);
  }, [limiting_drivers, supporting_drivers, i18n]);

  return (
    <>
      <SectionTitle
        title={t('creative_video_details.section_title.performance_section')}
        iconClassName="tim-icons icon-atom"
      />
      <div className="performance_section">
        <div className="performance_driving">
          <h3>{t('creative_video_details.performance.driving_title')}</h3>
          <div className="performance_value">{driving}</div>
        </div>
        <div className="performance_limit">
          <h4>{t('creative_video_details.performance.limit_title')}</h4>
          <div className="performance_value">{limiting}</div>
        </div>
      </div>
    </>
  );
};

export default PerformanceSection;
